/**
 * @module AEM
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */

/**
 * An abstract class to convert Angular components into Authorable Components
 * @abstract
 * @access public
 */
export abstract class AuthorableComponent<Type> {
  constructor() {}

  /**
   * Sets the data for the specified component. This is required as the AEM module will use this method to populate
   * component data
   * @param data Input data for AEM component
   */
  public abstract setData(data: Type): void;
}
